import React from 'react';
import { useStores } from 'hooks/useStores';
import { observer } from 'mobx-react-lite';

import stringifyPrice from 'utils/stringifyNumber';
import theme from 'theme';
import Eye from 'ati-ui-react/components/icons/Eye';
import { ViewsCountWrapper } from './ViewsCountStyles';

const ViewsCount = observer(() => {
  const {
    advertsStore: { currentAdvert },
  } = useStores();
  const viewsCount = currentAdvert.views_count || 0;
  return (
    <ViewsCountWrapper>
      <Eye color={theme.colors.limedSpruceLight} width={14} height={8} />
      <span className="text">{stringifyPrice(viewsCount)}</span>
    </ViewsCountWrapper>
  );
});

export default ViewsCount;
